export default __webpack_public_path__ + "static/media/Nihilistic Sash.1403e007.jpg";